import { render, staticRenderFns } from "./AvisoVeracidadEspecialidad.vue?vue&type=template&id=42a78dd8&scoped=true"
import script from "./AvisoVeracidadEspecialidad.vue?vue&type=script&lang=js"
export * from "./AvisoVeracidadEspecialidad.vue?vue&type=script&lang=js"
import style0 from "./AvisoVeracidadEspecialidad.vue?vue&type=style&index=0&id=42a78dd8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42a78dd8",
  null
  
)

export default component.exports